import { render, staticRenderFns } from "./VerifyMagicLink.vue?vue&type=template&id=3280556f&scoped=true"
import script from "./VerifyMagicLink.vue?vue&type=script&lang=js"
export * from "./VerifyMagicLink.vue?vue&type=script&lang=js"
import style0 from "./VerifyMagicLink.vue?vue&type=style&index=0&id=3280556f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3280556f",
  null
  
)

export default component.exports